(function () {

  'use strict';

  angular.module('PrinterIssue')

    .controller('PrinterIssueController', function (
      $scope, URLS, $location, PRINTER_ISSUES, $filter, PrinterListService, toastr,
      $routeParams, URL_PARAMS, NetworkListPaging, NetworkListService,
      EventServiceEvents, EventHandlerService, $timeout, currentTenant, enums, $rootScope,
      TenantListService) {

      $scope.printerIssue = null;
      $scope.printer = null;
      $scope.printerOriginal = null;
      $scope.printerIssueForm = {};
      $scope.networkListPaging = new NetworkListPaging();
      $scope.selectedNetwork = null;
      $scope.waitingForAnswer = false;
      $scope.me = null;
      $scope.helpCaption = 'HelpPrinterIssue';

      (function () {
        EventHandlerService.deRegisterListeners();
      })();

      $scope.$watch(function () {
        return $rootScope.currentUser;
      }, function () {
        if ($rootScope.currentUser) {
          $scope.me = $rootScope.currentUser;
          $scope.tenant = TenantListService.currentTenant;
          getPrinter();
        }
      });

      function getSolutions() {
        $scope.printerIssue = angular.copy(PRINTER_ISSUES[$scope.printer.info.creationState]);
      }

      $scope.trySavingPrinterWithIssues = function () {
        $scope.printerOriginal.trySavingPrinterWithIssues($scope.selectedNetwork, $scope.printer.info.ipAddress)
          .then(function (response) {
          })
          .catch(function () {
            retryPrinterCreation();
          });
      };

      function retryPrinterCreation() {
        $scope.waitingForAnswer = true;
        $scope.printerOriginal.retryCreation()
          .then(function () {
            $location.path(URLS.PRINTER_ISSUE_LIST);
            toastr.success($filter('translate')('WorkingOnIt'));
            evaluateCreationState();
          })
          .catch(function () {
            evaluateCreationState();
          });
      }

      $scope.changeSelectedNetwork = function (network) {
        $scope.selectedNetwork = network;
      };

      $scope.networkSelectPopup = function (event) {
        event.stopPropagation();
        $scope.clearPopups();
        $scope.networkListPaging.pagingCriteria.pageSize = 5;
        $scope.networkListPaging.pagingCriteria.match = null;
        $scope.networkSelectConfiguration = {
          paginationObject: $scope.networkListPaging,
          placeholderText: 'Search',
          service: 'NetworkListService',
          contentHeight: 463
        };
        $scope.networkSelectPopupObject = {
          dimensions: { height: 463, width: 400 },
          offset: { top: 31, left: 60 },
          pointerDirection: 'right',
          pointerPosition: 'right',
          relativePosition: 'under',
          absoluteX: event.clientX,
          absoluteY: event.clientY,
          context: 'selectNetwork',
          type: 'PAGINATION',
          title: 'SelectNetwork',
          confirmText: 'SelectNetwork'
        };
      };

      $scope.clearPopups = function () {
        $scope.networkSelectConfiguration = null;
        $scope.networkSelectPopupObject = null;
      };

      function isThisResourceMine(network) {
        const siteUrl = network.info._links['px:site'] ? network.info._links['px:site'].href : null;
        $scope.isThisResourceMine = $scope.me.isThisSiteMine(siteUrl);
      }

      function getNetwork() {
        if ($scope.printer.info._links['px:network']) {
          const networkUrlParts = $scope.printer.info._links['px:network'].href.split('/');
          const networkId = networkUrlParts[networkUrlParts.length - 1];
          NetworkListService.getNetworkById(networkId)
            .then(function (network) {
              $scope.selectedNetwork = network;
              isThisResourceMine(network);
            })
            .catch(function () {
            });
        }
      }

      function getPrinter() {
        if ($routeParams[URL_PARAMS.PRINTER_URL.ROUTE]) {
          const url = $scope.tenant.info._links['px:printers'].href + '/' + $routeParams[URL_PARAMS.PRINTER_URL.ROUTE];
          PrinterListService.getPrinterByURL(url)
            .then(function (printer) {
              $scope.printerOriginal = printer;
              $scope.printer = angular.copy(printer);
              getNetwork();
              getSolutions();
              evaluateCreationState();
            })
            .catch(function () {
            });
        } else {
          $location.path(URLS.USER_LIST);
        }
      }

      function evaluateCreationState() {
        if ($scope.printer.info.creationState === 'RETRIEVING_MODEL') {
          $scope.waitingForAnswer = true;
        } else {
          $scope.waitingForAnswer = false;
        }
      }

      function updatePrinter(url) {
        PrinterListService.getPrinterByURL(url)
          .then(function (printer) {
            $scope.printerOriginal = printer;
            $scope.printer = angular.copy(printer);
            getNetwork();
            getSolutions();
            retryPrinterCreation();
          })
          .catch(function () {
          });
      }

      $scope.openContext = function (event, context, menuOption) {
        $scope.closeAllMenues();
        $timeout(function  () {
          $scope.selectedContextMenuItem = menuOption;
          $scope.contextContentPosition = { left: event.clientX, top: event.clientY };
          $scope.contextPosition = { left: event.clientX, top: event.clientY };
          $scope.contextContent = context;
          $scope.context = context;
          $scope.auxiliaries = {
            tenant: currentTenant,
            enums,
            network: $scope.selectedNetwork,
            me: $scope.me
          };
        });
      };

      $scope.closeAllMenues = function () {
        $scope.selectedContextMenuItem = null;
        $scope.contextContentPosition = null;
        $scope.contextPosition = null;
        $scope.contextContent = null;
        $scope.context = null;
        $scope.auxiliaries = null;
      };

      $scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_USERS.EVENTS.PRINTER_UPDATE, function (event, data) {
        if ($scope.printer.info._links.self.href === data.printer) {
          updatePrinter(data.printer);
        }
      });

    });

})();
